module.exports = __webpack_public_path__ + "static/media/ignition.201f72a8.svg";